/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpsertListingsItemsRequest
 */
export interface RequestUpsertListingsItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertListingsItemsRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpsertListingsItemsRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestUpsertListingsItemsRequest interface.
 */
export function instanceOfRequestUpsertListingsItemsRequest(value: object): value is RequestUpsertListingsItemsRequest {
    return true;
}

export function RequestUpsertListingsItemsRequestFromJSON(json: any): RequestUpsertListingsItemsRequest {
    return RequestUpsertListingsItemsRequestFromJSONTyped(json, false);
}

export function RequestUpsertListingsItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpsertListingsItemsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestUpsertListingsItemsRequestToJSON(json: any): RequestUpsertListingsItemsRequest {
    return RequestUpsertListingsItemsRequestToJSONTyped(json, false);
}

export function RequestUpsertListingsItemsRequestToJSONTyped(value?: RequestUpsertListingsItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

